import { Routine } from 'redux-saga-routines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  createEmailTemplate as createEmailTemplateService,
  updateEmailTemplate as updateEmailTemplateService,
  getUserEmailTemplates,
  getCandidateTemplateCode,
  getReferenceTemplateCode
} from '../../../../services/emailTemplateService';
import {
  fetchEmailTemplatesRoutine,
  createEmailTemplateRoutine,
  updateEmailTemplateRoutine,
  getCandidateTemplateCodeRoutine,
  getReferenceTemplateCodeRoutine
} from '../../routines';

function* getEmailTempates() {
  try {
    const response = yield call(getUserEmailTemplates);
    yield put(fetchEmailTemplatesRoutine.success(response));
  } catch (error) {
    yield put(fetchEmailTemplatesRoutine.failure(error.message));
  }
}

function* watchGetEmailTempates() {
  yield takeEvery(fetchEmailTemplatesRoutine.TRIGGER, getEmailTempates);
}

function* createEmailTempate({ payload }: Routine<any>) {
  try {
    const response = yield call(createEmailTemplateService, payload);
    yield put(createEmailTemplateRoutine.success(response));
  } catch (error) {
    yield put(createEmailTemplateRoutine.failure(error.message));
  }
}

function* watchCreateEmailTempate() {
  yield takeEvery(createEmailTemplateRoutine.TRIGGER, createEmailTempate);
}

function* updateEmailTempate({ payload }: Routine<any>) {
  try {
    const response = yield call(updateEmailTemplateService, payload);
    yield put(updateEmailTemplateRoutine.success(response));
  } catch (error) {
    yield put(updateEmailTemplateRoutine.failure(error.message));
  }
}

function* watchUpdateEmailTempate() {
  yield takeEvery(updateEmailTemplateRoutine.TRIGGER, updateEmailTempate);
}

function* getCandidateTemplateCodeReq() {
  try {
    const { code } = yield call(getCandidateTemplateCode);
    yield put(getCandidateTemplateCodeRoutine.success(code));
  } catch (error) {
    yield put(getCandidateTemplateCodeRoutine.failure(error.message));
  }
}

function* watchGetCandidateTemplateCode() {
  yield takeEvery(getCandidateTemplateCodeRoutine.TRIGGER, getCandidateTemplateCodeReq);
}

function* getReferenceTemplateCodeReq() {
  try {
    const { code } = yield call(getReferenceTemplateCode);
    yield put(getReferenceTemplateCodeRoutine.success(code));
  } catch (error) {
    yield put(getReferenceTemplateCodeRoutine.failure(error.message));
  }
}

function* watchGetReferenceTemplateCode() {
  yield takeEvery(getReferenceTemplateCodeRoutine.TRIGGER, getReferenceTemplateCodeReq);
}

export default function* emailTemplatesSaga() {
  yield all([
    watchGetEmailTempates(),
    watchCreateEmailTempate(),
    watchUpdateEmailTempate(),
    watchGetCandidateTemplateCode(),
    watchGetReferenceTemplateCode()
  ]);
}
